import { Link } from 'react-router-dom';
import { FilePlus2, RefreshCw, AlertTriangle, Clock, PackageOpen, ClipboardCheck } from 'lucide-react';
import { useAchatsDashboard } from '@/hooks/useAchats';

/**
 * SIMG-ACHATS-LEADBETON-2026-002 — Accueil « Aujourd'hui » de l'acheteur.
 */
export const AccueilPage = () => {
  const { data, isLoading, refetch, isFetching } = useAchatsDashboard();

  const tiles = [
    { key: 'renvoyes',   to: '/achats/bca?statut=renvoyes',          icon: <AlertTriangle size={22} />, tone: 'danger',  titre: 'À corriger',      valeur: data?.renvoyesACorriger ?? 0, sous: 'renvoyés par le DAF' },
    { key: 'validation', to: '/achats/bca?statut=en_validation_daf', icon: <Clock size={22} />,         tone: 'info',    titre: 'Chez le DAF',      valeur: data?.enValidationDaf ?? 0, sous: 'en attente de validation' },
    { key: 'brouillons', to: '/achats/bca?statut=brouillon',         icon: <FilePlus2 size={22} />,     tone: 'warning', titre: 'Brouillons',       valeur: data?.brouillonsEnCours ?? 0, sous: 'à finaliser + soumettre' },
    { key: 'emis',       to: '/achats/bca?statut=emis',              icon: <PackageOpen size={22} />,   tone: 'success', titre: 'BCA envoyés',      valeur: data?.bcaEmisEnAttente ?? 0, sous: 'attente livraison' },
    { key: 'part',       to: '/achats/bca?statut=reception_partielle', icon: <ClipboardCheck size={22} />, tone: 'neutral', titre: 'Réceptions partielles', valeur: data?.receptionsPartielles ?? 0, sous: 'en cours' },
  ] as const;

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 800 }}>Aujourd'hui</h1>
          <p style={{ margin: '4px 0 0', color: 'var(--tx-3, #6B7280)', fontSize: 13 }}>
            Vue synthèse de tes achats en cours
          </p>
        </div>
        <button
          onClick={() => void refetch()}
          disabled={isFetching}
          style={{
            border: '1px solid var(--bd-1, #E5E7EB)', borderRadius: 8, background: '#fff',
            padding: '6px 10px', display: 'inline-flex', alignItems: 'center', gap: 6, cursor: 'pointer',
          }}
        >
          <RefreshCw size={14} className={isFetching ? 'animate-spin' : ''} /> Rafraîchir
        </button>
      </div>

      <Link
        to="/achats/nouveau"
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
          background: '#0F766E', color: '#fff',
          padding: '18px 20px', borderRadius: 14,
          fontWeight: 700, fontSize: 16, marginBottom: 20,
          boxShadow: '0 8px 24px -8px rgba(15,118,110,0.5)',
          textDecoration: 'none',
        }}
      >
        <FilePlus2 size={20} /> Nouveau bon de commande
      </Link>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 12 }}>
        {tiles.map((t) => (
          <Link key={t.key} to={t.to} style={{
            background: '#fff', border: `1px solid ${toneBorder(t.tone)}`,
            borderRadius: 12, padding: 16, textDecoration: 'none',
            color: 'inherit', display: 'flex', flexDirection: 'column', gap: 6,
            boxShadow: '0 2px 4px -2px rgba(0,0,0,0.05)', minHeight: 110,
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: toneColor(t.tone) }}>
              {t.icon}
              <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--tx-2, #374151)' }}>{t.titre}</span>
            </div>
            <div style={{ fontSize: 32, fontWeight: 800, lineHeight: 1, color: toneColor(t.tone) }}>
              {isLoading ? '…' : t.valeur}
            </div>
            <div style={{ fontSize: 11, color: 'var(--tx-3, #6B7280)' }}>{t.sous}</div>
          </Link>
        ))}
      </div>
    </div>
  );
};

function toneColor(t: string): string {
  return t === 'danger' ? '#B91C1C' : t === 'warning' ? '#B45309' : t === 'info' ? '#1E40AF' : t === 'success' ? '#047857' : '#374151';
}
function toneBorder(t: string): string {
  return t === 'danger' ? '#FECACA' : t === 'warning' ? '#FDE68A' : t === 'info' ? '#BFDBFE' : t === 'success' ? '#A7F3D0' : '#E5E7EB';
}
